import { useState, useEffect, useRef } from "react";
import { getHoursCloseTicketsAuto } from "../../config";
import toastError from "../../errors/toastError";

import api from "../../services/api";
import { getTickets } from "../../services/ticketQueries";

const useTickets = ({
    searchParam,
    pageNumber,
    status,
    date,
    ticketId,
    showAll,
    ticketType,
    queueIds,
    userIds,
    whatsappIds,
    tagIds,
    withUnreadMessages,
    refreshTrigger,
}) => {
    const [loading, setLoading] = useState(true);
    const [hasMore, setHasMore] = useState(false);
    const [tickets, setTickets] = useState([]);
    const [count, setCount] = useState(0);
    // Ordem que o servidor usou (Configuracoes da empresa): "recent" ou "oldest".
    const [order, setOrder] = useState("recent");
    const requestIdRef = useRef(0);
    const querySignatureRef = useRef("");
    const hasTicketsLoaded = tickets.length > 0;

    useEffect(() => {
        const requestId = ++requestIdRef.current;
        let active = true;
        const querySignature = JSON.stringify({
            searchParam,
            pageNumber,
            status,
            date,
            ticketId,
            showAll,
            ticketType,
            queueIds,
            userIds,
            whatsappIds,
            tagIds,
            withUnreadMessages,
        });
        const isMeaningfulReload = querySignatureRef.current !== querySignature;
        querySignatureRef.current = querySignature;

        if (isMeaningfulReload || !hasTicketsLoaded) {
            setLoading(true);
        }
        const delayDebounceFn = setTimeout(() => {
            const fetchTickets = async() => {
                try {
                    const { data } = await getTickets({
                        searchParam,
                        pageNumber,
                        status,
                        date,
                        ticketId,
                        showAll,
                        ticketType,
                        queueIds,
                        userIds,
                        whatsappIds,
                        tagIds,
                        withUnreadMessages,
                        _: refreshTrigger,
                    })
                    if (!active || requestId !== requestIdRef.current) return;

                    const loadedTickets = Array.isArray(data.tickets) ? data.tickets : [];
                    // Antes da lista: quem encaixa os chamados le a ordem.
                    setOrder(data.order === "oldest" ? "oldest" : "recent")
                    setTickets(loadedTickets)

                    let horasFecharAutomaticamente = getHoursCloseTicketsAuto(); 

                    if (status === "open" && horasFecharAutomaticamente && horasFecharAutomaticamente !== "" &&
                        horasFecharAutomaticamente !== "0" && Number(horasFecharAutomaticamente) > 0) {

                        let dataLimite = new Date()
                        dataLimite.setHours(dataLimite.getHours() - Number(horasFecharAutomaticamente))

                        loadedTickets.forEach(ticket => {
                            if (ticket.status !== "closed") {
                                let dataUltimaInteracaoChamado = new Date(ticket.updatedAt)
                                if (dataUltimaInteracaoChamado < dataLimite)
                                    closeTicket(ticket)
                            }
                        })
                    }

                    setHasMore(data.hasMore)
                    setCount(data.count)
                    setLoading(false)
                } catch (err) {
                    if (!active || requestId !== requestIdRef.current) return;
                    setLoading(false)
                    toastError(err)
                }
            }

            const closeTicket = async(ticket) => {
                await api.put(`/tickets/${ticket.id}`, {
                    status: "closed",
                    userId: ticket.userId || null,
                })
            }

            fetchTickets()
        }, 500)
        return () => {
            active = false;
            clearTimeout(delayDebounceFn)
        }
    }, [
        searchParam,
        pageNumber,
        status,
        date,
        ticketId,
        showAll,
        ticketType,
        queueIds,
        userIds,
        whatsappIds,
        tagIds,
        withUnreadMessages,
        refreshTrigger,
    ])

    return { tickets, loading, hasMore, count, order };
};

export default useTickets;
